import React, { ComponentClass } from 'react';
import PaddingBox from '@uds/padding-box';
import { Container } from '@uds/grid';
import visibilitySet from 'presentation/hocs/visibilitySet';
import Ribbon, { Flush } from 'components/ribbons/Ribbon';
import errorBoundary from 'presentation/hocs/errorBoundary';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import { ShortcodeProps } from 'presentation/components/Shortcode';

import Caveat from './Caveat';

type CaveatProps = {
  body: ShortcodeProps;
};
export interface OuterProps extends RibbonProps {
  caveats: Array<CaveatProps>;
}

export const LegalCaveat = ({ id, colorway, layout, loading, name, caveats }: OuterProps) => {
  const caveatsWithIndex = caveats.map((item, index) => ({
    ...item,
    index: `Caveats${index}${id}`,
  }));

  return (
    <Ribbon
      id={id}
      colorway={colorway}
      layout={layout}
      loading={loading}
      name={name}
      flush={Flush.LEADING}
      type={Type.LEGAL}
    >
      <Container>
        <PaddingBox>
          {caveatsWithIndex.map((caveat) => (
            <Caveat key={caveat.index} colorway={colorway} {...caveat} />
          ))}
        </PaddingBox>
      </Container>
    </Ribbon>
  );
};

LegalCaveat.displayName = 'Legal';

export default errorBoundary(visibilitySet(LegalCaveat)) as ComponentClass<OuterProps>;
